import React from 'react'
import { Col, Row } from 'reactstrap'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import CmsHomepageSectionTable from 'domains/cms-homepage-section/table/cms-homepage-section-table'

const propTypes = {
  banners: PropTypes.array
}

const defaultProps = {
  banners: []
}

const BANNER_PLATFORM                   = {
  WEB    : 'web',
  MOBILE : 'mobile'
}
const CmsHomepageSectionCarouselBanners = ({ banners }) => {

  const webSections    = banners.filter((banner) => banner.platform === BANNER_PLATFORM.WEB)
  const mobileSections = banners.filter((banner) => banner.platform === BANNER_PLATFORM.MOBILE)
  const history        = useHistory()
  const handleClickRow = (section) => {
    history.push({
      pathname: `sections/${section.id}`
    })
  }
  return (
    <>

      <Row>
        <Col
          xs={ 12 }
          md={ 6 }
        >
          <div className='h3'>Web Section</div>
          <CmsHomepageSectionTable
            hover
            style={{ backgroundColor: 'white' }}
            size='sm'
            sections={ webSections }
            onClickRow={ handleClickRow }
          />
        </Col>
        <Col
          xs={ 12 }
          md={ 6 }
        >

          <div className='h3'>Mobile Section</div>
          <CmsHomepageSectionTable
            hover
            style={{ backgroundColor: 'white' }}
            size='sm'
            sections={ mobileSections }
            onClickRow={ handleClickRow }
          />
        </Col>

      </Row>
    </>
  )
}


CmsHomepageSectionCarouselBanners.propTypes    = propTypes
CmsHomepageSectionCarouselBanners.defaultProps = defaultProps

export default CmsHomepageSectionCarouselBanners
